<template>
  <label class="file-select">
    <div class="select-button" style="padding: 0.5rem;">
      <span>Enviar imagem</span>
    </div>
    <input type="file" accept="image/x-png,image/gif,image/jpeg" @change="handleFileChange"/>
  </label>
</template>

<script>
export default {
  name: "FileSelectCheckout",
  props: ['cartItem', 'itemNumber'],
  methods: {
    handleFileChange(e) {
      this.$emit('input', e.target.files[0])
      this.$parent.uploadFile(this.cartItem, this.itemNumber)
    }
  }
}
</script>

<style scoped>
.file-select > .select-button {
  padding: 1rem;

  color: white;
  background-color: #1e7121;

  border-radius: .3rem;

  text-align: center;
  font-weight: bold;
}

.file-select > input[type="file"] {
  display: none;
}
</style>
